export class NgxGalleryAnimation {
    static Fade: string = 'fade';
    static Slide: string = 'slide';
    static Rotate: string = 'rotate';
    static Zoom: string = 'zoom';
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/~/ngx-gallery/lib/ngx-gallery-animation.model.ts